const CommunicationsModule = () => import('@pages/communications/Module')
const meetingIndex = () => import('@pages/communications/meetings/Index')
const MeetingCreate = () => import('@pages/communications/meetings/Create')
const MeetingInvitationsIndex = () => import('@pages/communications/meetings/MeetingInvitationsIndex')
const NewsletterIndex = () => import('@pages/communications/newsletters/NewsletterIndex')
const NewsletterDistribution = () => import('@pages/communications/newsletters/NewsletterDistribution')
const NewsletterCreate = () => import('@pages/communications/newsletters/NewsletterCreate')
// const NewsletterInternals = () => import('@pages/communications/newsletters/NewsletterInternals')
const SurveyIndex = () => import('@pages/communications/surveys/SurveyIndex')
const SurveyCreate = () => import('@pages/communications/surveys/SurveyCreate')
const SurveyPublicView = () => import('@pages/communications/surveys/SurveyPublicView')
const SurveyPrivateView = () => import('@pages/communications/surveys/SurveyPrivateView')
const ModifyMeetingRecord = () => import('@pages/communications/meetings/ModifyMeetingRecord')
const ArchiveIndex = () => import('@pages/communications/archives/ArchiveIndex')
const SystemMessageIndex = () => import('@pages/communications/systemMessages/SystemMessageIndex')
const SystemMessageCreate = () => import('@pages/communications/systemMessages/SystemMessageCreate')
const AutomaticReminders = () => import('@pages/communications/reminders/Index')
const AutomaticRemindersForm = () => import('@pages/communications/reminders/ReminderForm')
const NewsletterTemplateCreate = () => import('@pages/communications/newsletters/templates/NewsletterTemplateCreate')
const NewsletterTemplateIndex = () => import('@pages/communications/newsletters/templates/NewsletterTemplateIndex')
const ClientNewsletterCreate = () => import('@pages/communications/newsletters/ClientNewsletterCreate')

export default {
    path: 'communications',
    component: CommunicationsModule,
    children: [
        {
            path: 'meetings',
            component: meetingIndex,
            name: 'meetings',
        },
        {
            path: 'create-meeting',
            component: MeetingCreate,
            name: 'createMeeting',
            props: true,
        },
        {
            path: 'meetings/:currentMeetingId/edit',
            component: MeetingCreate,
            name: 'editMeeting',
            props: true,
        },
        {
            path: 'meetings/:currentMeetingId/view',
            component: MeetingCreate,
            name: 'viewMeeting',
            props: true,
        },
        {
            path: 'meeting-invitations',
            component: MeetingInvitationsIndex,
            name: 'meetingInvitations',
        },
        {
            path: ':meetingId/modify-meeting-record',
            component: ModifyMeetingRecord,
            name: 'modifyMeetingRecord',
            props: true,
        },
        {
            path: 'newsletter',
            component: NewsletterIndex,
            name: 'newsletter',
        },
        {
            path: 'newsletter-distribution',
            component: NewsletterDistribution,
            name: 'newsletter-distribution',
        },
        {
            path: 'newsletter-create',
            component: NewsletterCreate,
            name: 'newsletter-create',
            props: true,
        },
        {
            path: 'client-newsletter-create',
            component: ClientNewsletterCreate,
            name: 'client-newsletter-create',
        },
        {
            path: 'archives',
            component: ArchiveIndex,
            name: 'archives',
        },
        {
            path: 'system-messages',
            component: SystemMessageIndex,
            name: 'systemMessages',
        },
        {
            path: 'system-message-create',
            component: SystemMessageCreate,
            name: 'systemMessageCreate',
        },
        {
            path: 'system-messages/:id/edit',
            component: SystemMessageCreate,
            name: 'systemMessageEdit',
            props: true,
        },
        {
            path: ':currentNewsletterId/newsletter-edit',
            component: NewsletterCreate,
            name: 'newsletter-edit',
        },
        {
            path: ':currentNewsletterId/newsletter-clone',
            component: NewsletterCreate,
            name: 'newsletter-clone',
        },
        // {
        //     path: 'newsletter-internals',
        //     component: NewsletterInternals,
        //     name: 'newsletterInternals',
        // },
        {
            path: 'surveys',
            component: SurveyIndex,
            name: 'surveyIndex',
        },
        {
            path: 'surveys/create',
            component: SurveyCreate,
            name: 'surveyCreate',
        },
        {
            path: 'surveys/:currentSurveyId/edit',
            component: SurveyCreate,
            name: 'surveyEdit',
            props: true,
        },
        {
            path: 'survey/:currentSurveyId/public',
            component: SurveyPublicView,
            name: 'surveyPublicView',
            props: true,
        },
        {
            path: 'survey/:currentSurveyId/private',
            component: SurveyPrivateView,
            name: 'surveyPrivateView',
            props: true,
        },
        {
            path: 'automatic-reminders',
            component: AutomaticReminders,
            name: 'automaticReminders',
        },
        {
            path: 'reminder-create',
            component: AutomaticRemindersForm,
            name: 'reminder-create',
        },
        {
            path: ':currentReminderId/reminder-edit',
            component: AutomaticRemindersForm,
            name: 'reminder-edit',
        },
        {
            path: 'newsletter-template-create',
            component: NewsletterTemplateCreate,
            name: 'newsletterTemplateCreate',
        },
        {
            path: 'newsletter-template-index',
            component: NewsletterTemplateIndex,
            name: 'newsletterTemplateIndex',
        },
        {
            path: ':currentTemplateId/template-edit',
            component: NewsletterTemplateCreate,
            name: 'newsletterTemplateEdit',
        },
    ],
}
